import { useContext } from "react";
import { Navigate, useParams } from "react-router-dom";
import AppContext from "../../Context/AppContext";

function ResightingAssignments() {
  const appStates = useContext(AppContext);
  const authStat = appStates.getAuthStat();
  const { role, recordId } = useParams();

  if (authStat === "QC") {
    if (role === "qc" && recordId) {
      return <Navigate to={`/home/resighting/qc/record/${recordId}`} replace />;
    }
    return <Navigate to="/home/resighting/qc" replace />;
  }

  if (authStat === "Admin") {
    if (role === "admin" && recordId) {
      return <Navigate to={`/home/resighting/admin/record/${recordId}`} replace />;
    }
    return <Navigate to="/home/resighting/admin" replace />;
  }

  if (authStat === "Supervisor") {
    if (role === "supervisor" && recordId) {
      return (
        <Navigate
          to={`/home/resighting/supervisor/record/${recordId}`}
          replace
        />
      );
    }
    return <Navigate to="/home/resighting/supervisor" replace />;
  }

  return <Navigate to="/home" replace />;
}

export default ResightingAssignments;
